export const AJOUTE_RESERVATION = "AJOUTE_RESERVATION";
export const SUPRIMER_RESERVATION = "SUPRIMER_RESERVATION";